import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as T_T from 'cryface';
import { WechatDelegate } from '../../../services/DataDelegate/WechatDelegate/wechat.delegate';

@Component
export default class BrokerageReport extends Vue {
   public title: string = 'BrokerageReport';
   public output: any = null;

   public wechat = new WechatDelegate();

   public modal = false;

   @Prop()
   public reportId: any;

   @Watch('reportId', { immediate: true, deep: true })
   public onIdInput(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         this.reportId = val;
         // console.log(this.reportId);
      }
   }

   @Watch('$store.state.printerOb', { immediate: true, deep: true })
   public onPrintNext(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         if (this.reportId === val.next) {
            this.letsCapture();
         }
      }
   }

   public async letsCapture() {
      // console.log(ref);
      this.$Loading.start();
      const el = this.$refs.printMe;
      // // add option type to get the image version
      // // if not provided the promise will return
      // // the canvas.
      const options = {
         type: 'dataURL'
      };
      const _this: any = this;
      this.output = await _this.$html2canvas(el, options);
      // this.output = dataURItoBlob(this.output!);
      this.modal = true;
      this.$Loading.finish();
   }

   public async handlePrint() { }

   public async handleDownload() { }

   public dataURItoBlob(dataURI: string | null) {
      if (dataURI) {
         // convert base64 to raw binary data held in a string
         // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
         const byteString = atob(dataURI.split(',')[1]);

         // separate out the mime component
         const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

         // write the bytes of the string to an ArrayBuffer
         const ab = new ArrayBuffer(byteString.length);
         const ia = new Uint8Array(ab);
         for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
         }
         const convertedUrl = window.URL.createObjectURL(new Blob([ab], { type: mimeString }));
         return convertedUrl;
      }
   }

   public isWechat() {
      return this.wechat.isWeChat();
   }
}
